import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.NoBankAccountsPlaceholder', {
    noBankAccountsYet: "Don't have a bank account connected yet?",
    addBankAccount: 'Add bank account',
});
